module.exports = __webpack_public_path__ + "static/media/Montserrat-ThinItalic.5cd51f31.ttf";